import styled from "@emotion/styled";

import bgimg from "../../../assets/images/bgimage.png"
const Wrapper = styled.div`
  /* min-height: 100vh; */
  background-image: url(${bgimg});
  background-size: cover;
  background-position: center;    
  background-repeat: no-repeat;
  background-position: bottom;
`;
export{Wrapper}



























































